export default "__VITE_ASSET__LmShKPq88Se_$7tMl85WwQ__"